import React from 'react'
import './Footer.scss'

export default function Footer() {
  return (
    <footer className='footer'>
        <h3>Portfolio 2024 ©</h3>
    </footer>
  )
}
